import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";

import Textarea from "~/common/components/textarea";
import Form from "~/common/components/Form";

// Assets
import "~/assets/sass/pages/invest/IrModal/common.scss";

import logoImg from "~/assets/img/defaultImg/dark-logo-square.png";
import AlertTemplate from "~/common/components/AlertPortal/AlertTemplate";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import { useNavigate } from "react-router";
import { Trans, useTranslation } from "react-i18next";
const ResultAnnounceModal = ({
	resultAnnounceModal,
	setResultAnnounceModal,
	info,
	irInfo,
	company,
	param,
	detailRequest,
	investInfo,
}) => {
	const { t } = useTranslation();
	const [resultAnnounceChkAlert, setResultAnnounceChkAlert] = useState(false);
	const [resultAnnounceAlert, setResultAnnounceAlert] = useState(false);
	const notificationForm = useForm();
	const investResultRequest = useRequest("post", "/vc/invest/result/" + param.idx);

	const notificationSend = notificationForm.watch("notification");
	const navigate = useNavigate();
	const submitResult = () => {
		const dataForm = { comment: notificationSend };
		investResultRequest.singleCall(dataForm);
	};

	const reloadDetail = () => {
		setResultAnnounceAlert(false);
		setResultAnnounceChkAlert(false);
		setResultAnnounceModal(false);
		detailRequest.singleCall(param.idx, "path");
	};

	useEffect(() => {
		switch (investResultRequest.state) {
			case API_STATE.done:
				setResultAnnounceAlert(true);
				navigate(`/invest/evaluate/detail/${param.idx}`);
				window.location.reload();
				break;
			case API_STATE.error:
				console.log(" resultAPI error", investResultRequest.error);
				break;
			default:
				break;
		}
	}, [investResultRequest.state, investResultRequest.response, investResultRequest.error]);

	return (
		<>
			<ModalTemplate
				modalState={resultAnnounceModal}
				setModalToggle={setResultAnnounceModal}
				title={
					<div className="top">
						<div className="img-wrap">
							<img
								src={investInfo?.StartupCompany?.logoSqu || logoImg}
								alt={t(
									"pages.investment.InvestEvalPage.detail.Step.modalForJudge.ResultAnnounceModal.imageAlt"
								)}
							/>
						</div>
						<h4 className="title pre">
							<b>{irInfo?.IRBasicInfo?.name}</b>
							{t(
								"pages.investment.InvestEvalPage.detail.Step.modalForJudge.ResultAnnounceModal.title"
							)}
						</h4>
					</div>
				}
				width={600}
				className="evaluate-notification-modal"
			>
				<div className="modal-content">
					<Form useForm={notificationForm} className="notification-form vertical">
						<Textarea
							label={
								<>
									{t(
										"pages.investment.InvestEvalPage.detail.Step.modalForJudge.ResultAnnounceModal.sender"
									)}{" "}
									<span className="sender">
										{info.name} ({company.name})
									</span>
								</>
							}
							name="notification"
							placeholder={t(
								"pages.investment.InvestEvalPage.detail.Step.modalForJudge.ResultAnnounceModal.placeholder"
							)}
							// showCount={true}
						/>
					</Form>
				</div>
				<div className="modal-footer">
					<button
						type="button"
						className="btn__solid"
						color="gray"
						onClick={() => setResultAnnounceModal(false)}
					>
						{t(
							"pages.investment.InvestEvalPage.detail.Step.modalForJudge.ResultAnnounceModal.button01"
						)}
					</button>
					<button
						type="button"
						className="btn__solid"
						color="primary"
						onClick={() => setResultAnnounceChkAlert(true)}
					>
						{t(
							"pages.investment.InvestEvalPage.detail.Step.modalForJudge.ResultAnnounceModal.button02"
						)}
					</button>
				</div>
			</ModalTemplate>
			{/*----------- 결과통보 버튼 클릭 시 모달 - 심사 결과 전달 check*/}
			<AlertTemplate
				alertModalState={resultAnnounceChkAlert}
				setAlertModalToggle={setResultAnnounceChkAlert}
				alertType="warning"
				className="evaluate-notification-modal"
			>
				<p className="alert-content">
					<div className="modal-text">
						<Trans
							i18nKey="pages.investment.InvestEvalPage.detail.Step.modalForJudge.ResultAnnounceModal.alert01"
							components={[irInfo?.IRBasicInfo?.name, <b />]}
						/>
					</div>
				</p>
				<div className="alert-footer">
					<button className="btn__solid" color="primary" onClick={submitResult}>
						{t(
							"pages.investment.InvestEvalPage.detail.Step.modalForJudge.ResultAnnounceModal.button03"
						)}
					</button>
					<button
						className="btn__solid"
						color="gray"
						onClick={() => setResultAnnounceChkAlert(false)}
					>
						{t(
							"pages.investment.InvestEvalPage.detail.Step.modalForJudge.ResultAnnounceModal.button04"
						)}
					</button>
				</div>
			</AlertTemplate>
			{/*----------- 결과통보 버튼 클릭 시 모달 - 심사 결과 전달 완료*/}
			<AlertTemplate
				alertModalState={resultAnnounceAlert}
				setAlertModalToggle={setResultAnnounceAlert}
				alertType="success"
			>
				<p className="alert-content">
					<div className="modal-text">
						{t(
							"pages.investment.InvestEvalPage.detail.Step.modalForJudge.ResultAnnounceModal.alert02"
						)}
					</div>
				</p>
				<div className="alert-footer">
					<button className="btn__solid" color="primary" onClick={reloadDetail}>
						{t(
							"pages.investment.InvestEvalPage.detail.Step.modalForJudge.ResultAnnounceModal.button05"
						)}
					</button>
				</div>
			</AlertTemplate>
		</>
	);
};

export default ResultAnnounceModal;
